export const ThirdPartyResponseStatus = {
  AwaitingReview: 'awaiting_review',
  Completed: 'completed',
  Expired: 'expired',
  InProgress: 'in_progress',
  NotStarted: 'not_started',
  Recalled: 'recalled',
  Rejected: 'rejected',
} as const;

export type ThirdPartyResponseStatus =
  (typeof ThirdPartyResponseStatus)[keyof typeof ThirdPartyResponseStatus];

/**
 * Statuses from which an invited third-party respondent may no longer edit
 * their questionnaire response (RSP-6570). The single source of truth for
 * "respondent-editable" across EVERY respondent write path — answer saves
 * (`third_party_response` update) and attachment detach
 * (`relation_file` delete) — plus the portal's `readOnly` form gate.
 *
 * It previously lived as three independent copies (one per consumer) and they
 * drifted: `Expired` was added to the answer-save guard but not to the
 * attachment-detach guard or the UI gate, so an expired respondent was blocked
 * from saving answers yet could still permanently detach their attachments.
 * Keep this list as the ONLY definition — a new locked state must apply to
 * every respondent write at once.
 *
 * `Expired` is locked: once the invite window closes the respondent must not
 * be able to edit or re-submit. `NotStarted` and `InProgress` are the only
 * editable states.
 */
export const RESPONDENT_LOCKED_STATUSES: ThirdPartyResponseStatus[] = [
  ThirdPartyResponseStatus.AwaitingReview,
  ThirdPartyResponseStatus.Completed,
  ThirdPartyResponseStatus.Expired,
  ThirdPartyResponseStatus.Recalled,
  ThirdPartyResponseStatus.Rejected,
];
